import React from "react";
import { Container } from "react-bootstrap";
import {Link} from 'react-router-dom'
import './Footer.css'
const Footer = () => {
  return (
    <div className="footer">
      <Container>
        <div className="main-footer">
        <div className="row">
          <div className="col-6 col-md-4 col-lg-4 col-xl-3">
            <div className="footer-item">
              <h4 className="fw-light">Usefull links</h4>
              <ul>
                <li><Link to="#">Todays Hot Deal</Link></li>
                <li><Link to="#">Offer for Now</Link></li>
                <li><Link to="#">New Arrival</Link></li>
                <li><Link to="#">Hot Products</Link></li>
                <li><Link to="#">Best Sale</Link></li>
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-4 col-xl-3">
            <div className="footer-item">
              <h4 className="fw-light">Main Pages</h4>
              <ul>
                <li><Link to="#">Home Page</Link></li>
                <li><Link to="#">Offer Page</Link></li>
                <li><Link to="#">Contact Page</Link></li>
                <li><Link to="#">404 Page</Link></li>
                <li><Link to="#">Login/Registration</Link></li>
                <li><Link to="#">All Products</Link></li>
                <li><Link to="#">About Page</Link></li>
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-4 col-xl-3">
            <div className="footer-item">
              <h4 className="fw-light">Sub Pages</h4>
              <ul>
                <li><Link to="#">Product Details Page</Link></li>
                <li><Link to="#">Profile/Dashboard</Link></li>
                <li><Link to="#">Wishlist Page</Link></li>
                <li><Link to="#">Cart Page</Link></li>
                <li><Link to="#">Check Out Page</Link></li>
                <li><Link to="#">Order Page</Link></li>
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-4 col-xl-3">
            <div className="footer-item">
              <h4 className="fw-light">Contact Us</h4>
              <ul>
                <li><Link to="#">Product Details Page</Link></li>
                <li><Link to="#">Profile/Dashboard</Link></li>
                <li><Link to="#">Wishlist Page</Link></li>
                <li><Link to="#">Cart Page</Link></li>
                <li><Link to="#">Check Out Page</Link></li>
                <li><Link to="#">Order Page</Link></li>
              </ul>
            </div>
          </div>
        </div>
        </div>
        <div className="sub-footer lg-screen">
          <h4 className="fw-light">About gen Apparel</h4>
          <p className="text-light">Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente reiciendis nobis possimus ipsam odit ipsum officiis quaerat perspiciatis, explicabo sint, vitae fugit facilis rerum ducimus, temporibus vero molestiae illum nemo voluptatem ad commodi nam ratione voluptates. Quaerat quos tempore blanditiis nulla exercitationem, illo fugiat eius quasi odit laudantium perferendis eos officiis obcaecati dolorem optio ratione eum repellendus saepe asperiores corporis.</p>
        </div>
        <div className="last-footer text-center py-2">
          <p className="m-0 text-light">All rights reserved by iGen solutions limited</p>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
